import { Box, Grid } from '@material-ui/core'
import MuiAccordion, {
  AccordionProps as Props
} from '@material-ui/core/Accordion'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import {
  Theme,
  createStyles,
  makeStyles,
  TypographyVariant
} from '@material-ui/core/styles'
import * as React from 'react'

import Typography from '../base/Typography'
import Icon from '../icons/Icons'
import Tag, { SizeTags } from '../tags/Tags'

export interface Schedule {
  day: string
  startTime: string
  endTime: string
}

export type AccordionScheduleProps = {
  schedule: Schedule[]
  labelVariant?: TypographyVariant
  marginBottom?: number
  marginTop?: number
  sizes?: SizeTags
} & Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      background: 'transparent',
      outline: 'none',
      boxShadow: 'none',
      '::before': {
        background: 'transparent'
      }
    },
    accordionSummary: {
      minHeight: 0,
      margin: 0,
      height: theme.spacing(2.1),
      padding: '8px 0px',
      color: '#2F80ED'
    },
    expandSummary: {
      position: 'relative',
      top: -11
    },
    accordionDetail: {
      padding: 0,
      position: 'relative',
      bottom: 40
    },
    spaceLeft: {
      marginLeft: theme.spacing(1)
    },
    textColor: {
      color: theme.palette.grey[800]
    },
    scheduleLabel: {
      marginRight: 12
    },
    tag: {
      padding: '3px 0px',
      width: '34px'
    }
  })
)

export const AccordionSchedule: React.FC<AccordionScheduleProps> = (props) => {
  const { schedule, sizes, marginBottom, marginTop, labelVariant } = props
  const classes = useStyles()
  return (
    <MuiAccordion square className={classes.root}>
      <MuiAccordionSummary
        classes={{
          root: classes.accordionSummary,
          expanded: classes.expandSummary
        }}
        expandIcon={
          <Box color="#2F80ED">
            <Icon iconName="ArrowBottomIcon" size="small" />
          </Box>
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box>
          <Typography
            className={`${classes.textColor} ${classes.scheduleLabel}`}
            variant={labelVariant ? labelVariant : 'caption'}
            children="Schedule:"
          />
          <Typography
            variant={labelVariant ? labelVariant : 'caption'}
            children="View Schedule"
          />
        </Box>
      </MuiAccordionSummary>
      <MuiAccordionDetails className={classes.accordionDetail}>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="flex-start"
        >
          {schedule.map((days, index) => {
            return (
              <Box
                key={`scheduleDay-${index}`}
                marginTop={index === 0 ? marginTop : 0}
                marginBottom={index === schedule.length - 1 ? -5 : marginBottom}
              >
                <Tag
                  customVariant="secondary"
                  sizes={sizes ? sizes : 'xs'}
                  label={days.day}
                  className={classes.tag}
                />
                <Typography
                  className={classes.spaceLeft}
                  variant={labelVariant ? labelVariant : 'caption'}
                  children={`${days.startTime} - ${days.endTime}`}
                />
              </Box>
            )
          })}
        </Grid>
      </MuiAccordionDetails>
    </MuiAccordion>
  )
}

export default AccordionSchedule